import { Account } from '@app/models/account/account.model';
import { Employee } from '@app/models/employee/employee.model';

/**
 * EmployeeStatus is a combination of employee statuses (as known in the db) and more nuanced statuses.
 */
export type EmployeeStatus = 'active' | 'terminated' | 'onLeave' | 'onboarding' | 'invited' | 'notYetInvited' | null;

/**
 * getEmployeeStatus provides several statuses on top of what can be determined
 * just by looking at the status column.
 *
 * This function returns null if something unexpected happens.
 */
export function getEmployeeStatus(employee: Employee, account: Account): EmployeeStatus {
    // sanity check
    if (!employee?.isPersisted || !account?.isPersisted || employee.accountId !== account.id) {
        return null;
    }

    if (employee.isTerminated()) {
        return 'terminated';
    }

    if (employee.onLeave) {
        return 'onLeave';
    }

    if (employee.isActive()) {
        return 'active';
    }

    if (employee.isOnboarding() && account.isActive) {
        return 'onboarding';
    }

    if (employee.isOnboarding() && !employee.isOnboardingPending) {
        return 'invited';
    }

    if (employee.isOnboarding() && employee.isOnboardingPending) {
        return 'notYetInvited';
    }

    // this should never be hit
    return null;
}
